import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from "@core/services/authentication.service";
import { Role } from "@core/models/roles.enum";

export const roleGuard: CanActivateFn = (route) => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  const expectedRoles: Role[] = route.data['roles'] ?? [];
  const hasRole = auth.hasAnyRoles(expectedRoles);

  return hasRole ? true : router.parseUrl('/forbidden');
};
